import { NFT } from "../../pages/RaffflePage/types/RafffleTypes";

export enum SaleStatus {
  ACTIVE = "ACTIVE",
  ENDED = "ENDED",
  CANCELED = "CANCELED",
  ERROR = "ERROR",
  INACTIVE = "INACTIVE",
}

export enum SaleTicker {
  TON = "TON",
  RAFF = "RAFF",
  USDT = "USDT",
}

export interface ISaleEntry {
  id: number;
  address: string;
  contractData: ISaleContractData;
  created: Date;
  nft: NFT;
  nftName: string;
  status: SaleStatus;
  ownerAddress: string;
  isActive: boolean;
  ticker: SaleTicker;
  collectionAddress: string;
  lastCheckedAt: Date | null;
  collectionId: number | null;
  price: string;
}

export interface ISaleContractData {
  ticker: SaleTicker; // USDT | TON | RAFF
  version: string;
  createdAt: string;
  fullPrice: string;
  isComplete: string; // тут я так понял цифра -1  или 1 в строке
  nftAddress: string;
  contractType: number;
  royaltyAmount: string;
  marketplaceFee: string;
  royaltyAddress: string;
  nftOwnerAddress: string;
  marketplaceAddress: string;
  marketplaceFeeAddress: string;
  initialized: string;
}
